import { motion } from 'framer-motion';
import { ContactForm } from '../components/ContactForm';

export default function Contact() {
  return (
    <div data-testid="contact-page">
      {/* Hero Section */}
      <section className="py-20 md:py-32 bg-brand-accent">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            className="text-center max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <p className="text-brand-secondary font-semibold tracking-widest uppercase text-sm mb-4">
              Get In Touch
            </p>
            <h1 className="font-heading text-4xl md:text-6xl font-bold text-brand-primary mb-6">
              Contact Me
            </h1>
            <p className="text-slate-600 text-lg">
              Have a question or want to work together? Fill out the form below and I&apos;ll get back to
              you as soon as possible.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-2xl mx-auto px-6 md:px-12">
          <ContactForm />
        </div>
      </section>
    </div>
  );
}
